import script from "./ScentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ScentPage.vue?vue&type=script&setup=true&lang=js"

import "./ScentPage.vue?vue&type=style&index=0&id=11325206&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11325206"]])

export default __exports__